import React from 'react';
import { storyblokEditable } from 'gatsby-source-storyblok';
// eslint-disable-next-line max-len
import type { NewsletterSignup as INewsletterSignup } from '../../../../.storyblok/types/255103/storyblok-components';
import Col from '../../FlexboxGrid/Col';
import NewsletterSignupForm from '../../Newsletter/NewsletterSignupForm';

interface NewsletterSignupProps {
  blok: INewsletterSignup;
}

/**
 * The standalone newsletter signup form as a Storyblok blok, for the /newsletter landing page.
 *
 * The left offset / max-width below is deliberately kept in sync with the `newsletter-landing`
 * cssClass branch in SingleColumnTitleTextCta.jsx, so the heading, body copy and form all share
 * one content column.
 */
const NewsletterSignup = ({ blok }: NewsletterSignupProps) => (
  <Col {...storyblokEditable(blok)} xs={8} md={10} lg={12}>
    <div className="mt-[60px] w-full md:ml-[25%] md:mt-[75px] md:max-w-[460px]">
      <NewsletterSignupForm
        variant="standalone"
        label={blok.label}
        submitLabel={blok.submitLabel}
        privacyPolicyText={blok.disclaimerText}
      />
    </div>
  </Col>
);

export default NewsletterSignup;
